
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15.9 15.49"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_257_2","data-name":"Symbol 257 – 2","transform":"translate(-1226.298 -193.211)"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Path_3744","d":"M30.932 5.6c.056-.113 1.71-1.807 3.206-3.3a1.086 1.086 0 0 1 1.467-.056 1.081 1.081 0 0 1 .085 1.608C34.138 5.4 32.71 6.9 32.625 7.012","data-name":"Path 3744","transform":"translate(1205.489 192.016)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Path_3745","d":"M11.074 20.134l1.814 1.713a1.067 1.067 0 0 1 .269 1.109l-2.657 7.56S1.2 28.534 2 20.067c0 0 4.637 2.251 7.695 0a1.066 1.066 0 0 1 1.379.067z","data-name":"Path 3745","transform":"translate(1225.048 177.483)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Line_2043","d":"M0 0l4.2 4.2","data-name":"Line 2043","transform":"translate(1233.031 198.525)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Path_3746","d":"M3.5 30.1a4.452 4.452 0 0 0 3.965.067","data-name":"Path 3746","transform":"translate(1224.02 170.676)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Path_3747","d":"M10.3 37.549a5.169 5.169 0 0 0 3.058-1.949","data-name":"Path 3747","transform":"translate(1219.505 167.024)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Path_3748","d":"M19.6 42.191a9.039 9.039 0 0 0 1.882-3.091","data-name":"Path 3748","transform":"translate(1213.33 164.7)"}})])])
          )
        }
      }
    